import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Header.css';
import Navigation from './Navigation';

const Header: React.FC = () => {
    return (
        <nav className="navbar navbar-expand-lg" style={{background: 'linear-gradient(135deg, #2d4a2b 0%, #3e5c3a 50%, #4a6b47 100%)', borderBottom: '3px solid #8b9f3f'}}>
            <div className="container-fluid">
                <Link className="navbar-brand d-flex align-items-center" to="/">
                    <img src="/images/shield.png" alt="Uma Shankar Security Agency Shield" className="me-2" style={{width: '50px', height: '50px', borderRadius: '50%', border: '3px solid #8b9f3f'}} />
                    <div>
                        <h1 className="mb-0" style={{fontSize: '1.6rem', color: '#c8d68f', fontWeight: 'bold', textShadow: '1px 1px 2px rgba(0,0,0,0.5)'}}>
                            Uma Shankar Security Agency
                        </h1>
                        <p className="mb-0" style={{fontSize: '0.95rem', color: '#e8f0d4', fontStyle: 'italic', fontWeight: '500'}}>
                            We Save Your Assets
                        </p>
                    </div>
                </Link>
                
                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" style={{borderColor: '#c8d68f'}}>
                    <span className="navbar-toggler-icon" style={{backgroundImage: "url('data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%28200, 214, 143, 1%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e')"}}></span>
                </button>
                
                <div className="collapse navbar-collapse" id="navbarNav">
                    <Navigation />
                </div>
            </div>
        </nav>
    );
};

export default Header;